import { Card } from '@apps/web/components/ui/card';
import { type CoverageKpis } from '@apps/web/features/coverage/model/dashboard_model';
import { cn } from '@apps/web/lib/utils';

function KpiTile({
    label,
    value,
    detail,
}: {
    readonly label: string;
    readonly value: string;
    readonly detail: string;
}) {
    return (
        <Card className="gap-1 p-4">
            <div className="text-muted-foreground text-[11px] font-semibold tracking-wide uppercase">
                {label}
            </div>
            <div className="text-2xl font-semibold">{value}</div>
            <div className="text-muted-foreground text-xs">{detail}</div>
        </Card>
    );
}

export function CoverageKpiStrip({
    kpis,
    unknownOnlyActive,
    onToggleUnknownOnly,
}: {
    readonly kpis: CoverageKpis;
    readonly unknownOnlyActive: boolean;
    readonly onToggleUnknownOnly: () => void;
}) {
    return (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <KpiTile
                label="Caregivers shown"
                value={String(kpis.shownCount)}
                detail={`Of ${kpis.rosterCount} on roster`}
            />
            <button
                type="button"
                onClick={onToggleUnknownOnly}
                className={cn(
                    'rounded-xl text-left',
                    unknownOnlyActive && 'ring-primary ring-2',
                )}
                aria-pressed={unknownOnlyActive}
            >
                <Card className="hover:border-primary h-full gap-1 p-4">
                    <div className="text-muted-foreground text-[11px] font-semibold tracking-wide uppercase">
                        No availability data
                    </div>
                    <div className="text-2xl font-semibold">
                        {kpis.noAvailabilityCount}
                    </div>
                    <div className="text-muted-foreground text-xs">
                        {unknownOnlyActive
                            ? 'Showing only these. Click to clear.'
                            : 'Never shared availability. Click to view.'}
                    </div>
                </Card>
            </button>
        </div>
    );
}
